export default "__VITE_ASSET__oWQQ429E__"